export enum ScreenNames {
  KidsProfileCreationName = "kids_profile_creation_name",
  KidsProfileCreationParentPin = "kids_profile_creation_parent_pin",
  ManageTracking = "manage_tracking",
  ParentPinInput = "parent_pin_input",
  ProfileSelector = "profile_selector",
  ResetParentPin = "reset_parent_pin",
  ProfileSettings = "profile_settings",
  UpdateProfile = "update_profile",
  ParentPinCreation = "parent_pin_creation",
}
